export default __webpack_public_path__ + "static/media/logoweb824p.d562abf0.png";